module.exports = __webpack_public_path__ + "static/media/exclamation-black.da0a43e6.svg";